/**
 * @generated SignedSource<<21d33f865b48d63c45c9c044f69bd3cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useRecentItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItemsPaged">;
  readonly " $fragmentType": "useRecentItems";
};
export type useRecentItems$key = {
  readonly " $data"?: useRecentItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItems">;
};

import useRecentItemsRefetchableQuery_graphql from './useRecentItemsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "keyword"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": useRecentItemsRefetchableQuery_graphql
    }
  },
  "name": "useRecentItems",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useRecentItemsPaged"
    }
  ],
  "type": "Query"
};

(node as any).hash = "c7427eba8c734344b51198ca307b6328";

export default node;
